// Header affordance that returns the user to /launcher — the
// platform overview / cross-app entry point. Used in both the admin
// (`AppLayout`) and learner (`LearnLayout`) headers so users always
// have a way back to the X-One suite home.
//
// Post-MP17 the launcher is also the platform overview surface (one
// KPI tile per entitled app plus locked-app sales tiles), so this
// affordance does double duty: app-switcher AND home.

import { Link } from 'react-router-dom';
import { LayoutGrid } from 'lucide-react';

export function BackToAppsButton() {
  return (
    <Link
      to="/launcher"
      title="Security overview"
      aria-label="Security overview"
      className="inline-flex h-9 items-center gap-1.5 rounded-md px-2 text-sm text-muted-foreground transition-colors hover:bg-accent hover:text-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
    >
      <LayoutGrid className="h-4 w-4" />
      <span className="hidden md:inline">Apps</span>
    </Link>
  );
}
